import { createContext } from "react";

const ForexMgtContext = createContext({} as any);

export default ForexMgtContext;